<template>
  <Wrapper />
</template>

<script lang="ts">
import { defineComponent, ref, watchEffect } from "vue";
import * as Sentry from "@sentry/browser";

import Wrapper from "./components/Wrapper.vue";

import { AnalyticEvents } from "@fresh8/types/src/analytics";

import {
  createLayoutContext,
  provideLayoutSync
} from "@fresh8/vue-utils/src/dimensionSync";

import { installFonts } from "@fresh8/vue-utils/src/installFonts";
import { useHandleAnalytics, useAnalyticsContext } from "./lib/analytics";
import { useNoEvents } from "./hooks/useNoEvents";
import { useAnalytics } from "./hooks/useAnalytics";
import { injectDisplayEvents } from "./composition/displayEvents";

export default defineComponent({
  components: {
    Wrapper
  },
  setup() {
    const $handleAnalytics = useHandleAnalytics();
    installFonts();
    provideLayoutSync(createLayoutContext());
    useNoEvents();
    const { firstThreeMarketIds } = injectDisplayEvents();

    const resivedVisbileEvent = ref(false);

    const { handleViewed } = useAnalytics({}, "Impression");

    handleViewed(firstThreeMarketIds.value);

    window.addEventListener(
      "message",
      e => {
        if (e.data.type === "ad_visible" && !resivedVisbileEvent.value) {
          resivedVisbileEvent.value = true;
          $handleAnalytics(AnalyticEvents.VIEWABLE, "Impression");
          window.parent.postMessage({ type: "f8_stop_visible" }, "*");
        }
      },
      true
    );

    const analyticsContext = useAnalyticsContext();

    watchEffect(() => {
      Sentry.configureScope(scope => {
        scope.setTag("adTagId", analyticsContext?.value?.adtagID || "");
        scope.setTag("viewId", analyticsContext?.value?.viewID || "");
        scope.setTag("brandId", analyticsContext?.value?.brandID || "");
        scope.setTag("catalogueId", analyticsContext?.value?.catalogueID || "");
        scope.setTag("campaignId", analyticsContext?.value?.campaignID || "");
      });
    });

    return {};
  }
});
</script>

<style></style>
